<template>
  <!-- bootstrap-vue navbar -->
  <b-navbar toggleable type="inverse" variant="inverse">
    <div class="container">
      <b-nav-toggle target="nav_collapse"></b-nav-toggle>
      <router-link to="/" class="navbar-brand">F13 API Browser</router-link>
      <b-collapse is-nav id="nav_collapse">

        <b-nav is-nav-bar class="left-nav">
          <b-nav-item to="/" :exact=true>Events By ID</b-nav-item>
          <b-nav-item to="/events" :exact=true>Event Search</b-nav-item>
        </b-nav>

        <b-nav is-nav-bar class="ml-auto">
          <b-nav-item href="http://docs.ingresso.co.uk/" target="_blank">API Docs</b-nav-item>
        </b-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
export default {
  name: 'navbar'
}
</script>

<style lang="scss">
.left-nav {
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// Navbar.vue?54aaf07c